// El borde con el lente de inventario: traduce el vocabulario del silo al de la pantalla.
import type {
    InventoryLensCriticalResponseWire,
    InventoryLensListResponseWire,
    InventoryLensListView,
    InventoryLensSkuItem,
    InventoryLensView,
} from './contract';
import { formatStorage } from '@/shared/lib/format/capacity';

/** Nombre comercial con marca, modelo y capacidad. Vacío si el catálogo no tiene ninguno. */
export function productLabel(parts: {
    brand?: string | null;
    model?: string | null;
    capacity?: string | null;
}): string {
    return [parts.brand, parts.model, formatStorage(parts.capacity)]
        .map((part) => part?.trim() ?? '')
        .filter((part) => part.length > 0)
        .join(' ');
}

/** Filas de `critical` con su nombre; `unavailable`/`reason` quedan sin `undefined`. */
export function toSkuLensView(
    wire: InventoryLensCriticalResponseWire,
): InventoryLensView<InventoryLensSkuItem> {
    return {
        items: wire.items.map((item) => ({ ...item, productName: productLabel(item) })),
        unavailable: wire.unavailable === true,
        reason: wire.reason ?? null,
    };
}

/** Filas del modo lista, kits y servicios incluidos. */
export function toListView(wire: InventoryLensListResponseWire): InventoryLensListView {
    return {
        period: wire.period,
        items: wire.items,
        promotionsUnavailable: wire.sources?.promotions === 'UNAVAILABLE',
    };
}
